import { Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Registration } from '../../../types/registrationTypes';
import RegistrationsTable from '../components/registrationsTable';

interface Props {
  registrations: Registration[];
  fetching: boolean;
}

const Wrapper: FC<Props> = ({ registrations, fetching }) => {
  const { t } = useTranslation('registrations');

  return (
    <>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs style={{ marginTop: '20px' }}>
          <Typography variant="h4" component="div" gutterBottom>
            {t('registrations.general.ongoingRegistrations', { context: 'plural' })}
          </Typography>
        </Grid>
      </Grid>
      <RegistrationsTable registrations={registrations} fetching={fetching} />
      {registrations.length === 0 && !fetching && <Typography>{t('registrations.general.noRegistrationWasFound')}</Typography>}
    </>
  );
};

export default Wrapper;
